import { Model as o } from "../../../../../model.js";
class c extends o {
  constructor(i) {
    super(), this.proximityNotification = i.proximityNotification, this.proximityNotificationLocations = i.proximityNotificationLocations;
  }
}
export {
  c as LoyaltyProgrammeWalletModel
};
//# sourceMappingURL=loyaltyProgrammeWallet.model.js.map
